import { render, staticRenderFns } from "./ForestPlotSimple.vue?vue&type=template&id=348b73c0&"
import script from "./ForestPlotSimple.vue?vue&type=script&lang=js&"
export * from "./ForestPlotSimple.vue?vue&type=script&lang=js&"
import style0 from "./ForestPlotSimple.vue?vue&type=style&index=0&id=348b73c0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('348b73c0')) {
      api.createRecord('348b73c0', component.options)
    } else {
      api.reload('348b73c0', component.options)
    }
    module.hot.accept("./ForestPlotSimple.vue?vue&type=template&id=348b73c0&", function () {
      api.rerender('348b73c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ForestPlotSimple.vue"
export default component.exports